import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { LunexService } from '@root/modules/lunex/services/lunex.service';

@Component({
  selector: 'edex-stripe-txn',
  templateUrl: './stripe-txn.component.html',
  styleUrls: ['./stripe-txn.component.scss']
})
export class StripeTxnComponent implements OnInit {
  @Input() onPage:string = ''
  @Output() payrixTotal: EventEmitter<any> = new EventEmitter();
  dataSource:any[] = [];
  currentPageData:any[] = [];
  paginations = { total:0, pageSize:5}
  parixTotalAmount = 0;
  constructor(private lunexService: LunexService, private router: Router) { }

  ngOnInit() {
    this.getTransactions();
  }

  getTransactions() {
    this.lunexService.getStripeTransactions().subscribe(res => {
      if(res && res.status) {
        this.parixTotalAmount = 0;
        res.result.map(item => {
          this.parixTotalAmount += parseFloat(item.transactionAmount);
          item.txnType= item.paypalResponse ? 'Paypal' : item.stripeResponse ? 'Stripe' : 'Payrix';
          item.vCardNo = item.vCardNo || '-'
          let dt = new Date(item.createdAt);
          item.createdAt = `${dt.getFullYear()}-${dt.getMonth()+1}-${dt.getDate()} ${dt.getHours()}:${dt.getMinutes()}`
          let itmd:any = this.lunexService.fetchCutomerDetails(item);
          // item.paymentResponse = item.response;
          item.customer = itmd.customer
          item.stallerResponse = (item.stallerResponse) ? JSON.parse(item.stallerResponse) : null;
          if(item.merchantId != 'pk_live_51MVwuvCFv9B2FlUPKeYcsDWqw576B8bFgDDItQAbt9pAnkTijYkI5fuWiWIm4fI2J1PoPsnpo9B9YJ3KbWUjhJKs00vkVd1lOT'  && item.paymentProcessorType == "Stripe"){
            item.txnStatus = 'Test'
          }else{
            item.txnStatus = 'Live'
           }
          return item;
        })
        this.payrixTotal.emit({ total:this.parixTotalAmount});
        this.dataSource = res.result;
        this.paginations.total = this.dataSource.length;
        this.paginate();
      }
    })
  }

  paginate(pageNumber=0) {
    let currentIndex = pageNumber*this.paginations.pageSize;
    this.currentPageData = this.dataSource.slice(currentIndex, currentIndex+this.paginations.pageSize);
  }

  onPageChange(event: PageEvent) {
    console.log(event);
    this.paginations.pageSize = event.pageSize;
    this.paginate(event.pageIndex)
  }

  gotoDetails(item) {
    if(item.paymentResponse)
      this.router.navigate(['/ptorders'])
    else if(item.paypalResponse)
      this.router.navigate(['/paypalorders'])
    else if(item.stripeResponse)
      this.router.navigate(['/stripeorders'])
  }

}
